import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Dashboard } from "./components/dashboard";
import NotFound from "./pages/NotFound";
import AddPage from "./pages/Add";
import { InsightsDashboard } from "./components/insights-dashboard";
import EditPage from "./pages/Edit";
import RankingsPage from "./pages/Rankings";
import RankingDetailPage from "./pages/RankingDetail";
import ViewPage from "./pages/View";
import SiteHeader from "@/components/site-header";
import SiteFooter from "@/components/site-footer";
import LoginPage from "@/pages/Login";
import RegisterPage from "@/pages/Register";
import AuthGate from "@/components/auth-gate";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
            <BrowserRouter>
        <div className="min-h-screen flex flex-col">
          <SiteHeader />
          <main className="flex-1 pb-16 sm:pb-0">
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/" element={<AuthGate><Dashboard /></AuthGate>} />
              <Route path="/add" element={<AuthGate><AddPage /></AuthGate>} />
              <Route path="/view/:id" element={<AuthGate><ViewPage /></AuthGate>} />
              <Route path="/edit/:id" element={<AuthGate><EditPage /></AuthGate>} />
              <Route path="/insights" element={<AuthGate><InsightsDashboard /></AuthGate>} />
              <Route path="/rankings" element={<AuthGate><RankingsPage /></AuthGate>} />
              <Route path="/rankings/:key" element={<AuthGate><RankingDetailPage /></AuthGate>} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <SiteFooter />
        </div>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;





